/**
 * Кого можно улучшить (Krea): то же правило, что у сервера (`enhance.create`).
 * Отмеченное (`picked`) любого вида или загруженное (`upload`); улучшенное — нет.
 * Клип и недоделанную генерацию карточка отсекает сама. Модуль без импортов — его грузит `node --test`.
 */

export const ENHANCE_NEED_PICK = "Улучшить можно отмеченное «В улучшение» или загруженное — сначала поставьте «В улучшение»";

export type EnhanceRun = { generation_id: number; status: string };

/** Подсказка вместо кнопки «Улучшить»; `null` — кнопку показываем. Фото улучшают один раз: готовое или
 *  идущее улучшение (`runs` карточки) прячет кнопку, упавшее — нет (сервер: `enhance.create`). */
export function enhanceHint(kind: string, pick: string, runs: EnhanceRun[] = []): string | null {
  if (kind === "enhance") return "Улучшенное повторно не улучшается";
  const done = runs.find((r) => r.status === "done");
  if (done) return `Уже улучшено (#${done.generation_id})`;
  if (runs.some((r) => r.status === "queued" || r.status === "running")) return "Улучшение в работе";
  if (pick === "picked" || kind === "upload") return null;
  return ENHANCE_NEED_PICK;
}
